var valueInput = null
let interval = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  if (apElements){
    if (!valueInput) {
      valueInput = $(".customize-button .choice-list-variatnt-title")[0].innerHTML
    }
    if($(".customize-button input[type='radio']").is(":checked")) {
      $(".customize-button .choice-list-variatnt-title")[0].innerHTML = "Remove";
    } else {
      $(".customize-button .choice-list-variatnt-title")[0].innerHTML = valueInput;
    }
  }
}, 100);

let interval1 = setInterval(function () {
  let apElements = document.querySelector('#avpoptions-container__v2');
  let apValueCheckboxs = $('.apo-f--radio input:checked').val();
  let fontValue = null
  if (apElements){
    let elmentCheckboxs = $('.apo-f--radio .avp-productoptioncheckwrapper')
    for(let i = 0; i < elmentCheckboxs.length; i++) {
      let valueInputs = $($('.apo-f--radio .avp-productoptioncheckwrapper input')[i]).val()
      $(elmentCheckboxs[i]).css("font-family", valueInputs)
    }
    if (apValueCheckboxs) {
      fontValue = apValueCheckboxs
      $('.apo-f--text input').css('font-family', fontValue)
    }
  }
}, 100);